import { bool, str, num } from 'envalid';

/**
 * Environment configuration for the Search feature.
 *
 * The embedding service handles all embedding generation.
 * These variables configure the connection to that service.
 */
export class SearchEnvConfig {
  private static readonly schema = {
    EMBEDDING_SERVICE_URL: str({
      default: undefined,
      desc: 'URL of the embedding service. Required for semantic search and indexing.',
      example: 'http://localhost:3001',
    }),
    EMBEDDING_API_TOKEN: str({
      default: undefined,
      desc: 'Bearer token for embedding service authentication.',
      example: 'your-secret-token',
    }),
    EMBEDDING_MODEL_ID: str({
      default: undefined,
      desc: 'Model identifier for embeddings. Must match between indexing and search.',
      example: 'intfloat/multilingual-e5-base',
    }),
    EMBEDDING_VERSION: num({
      default: undefined,
      desc: 'Embedding preprocessing version. Increment when chunking/text prep changes.',
      example: '3',
    }),
    EMBEDDING_DIMENSION: num({
      default: undefined,
      desc: 'Vector dimension for the embedding model.',
      example: '768',
    }),
    SKIP_SEARCH_INDEX: bool({
      default: false,
      desc: 'When true, disables search indexing/queueing (useful for unit tests and SQLite-only environments).',
    }),
    SEARCH_TRACE: bool({
      default: false,
      desc: 'Enable detailed logging for hybrid search scoring and fusion.',
    }),
    SEARCH_RRF_K: num({
      default: 60,
      desc: 'RRF constant for general search fusion (higher = more weight to lower-ranked items).',
      example: '60',
    }),
    CONTEXT_GRAPH_RRF_K: num({
      default: 60,
      desc: 'RRF constant for context graph scoring (separate from search ranking).',
      example: '60',
    }),
    CONTEXT_GRAPH_SEMANTIC_BOOST: num({
      default: 1.0,
      desc: 'Weight multiplier for semantic rank list in context graph RRF (>1 boosts semantic).',
      example: '1.0',
    }),
    CONTEXT_GRAPH_TITLE_IDF_SAMPLE_SIZE: num({
      default: 800,
      desc: 'Sample size (documents) used to compute title token IDF for context graph scoring.',
      example: '800',
    }),
    CONTEXT_GRAPH_TITLE_IDF_TTL_MS: num({
      default: 10 * 60 * 1000,
      desc: 'TTL (ms) for context graph title IDF cache.',
      example: '600000',
    }),
  } as const;

  private constructor() {}

  public static getSchema() {
    return SearchEnvConfig.schema;
  }
}
